module.exports = __webpack_public_path__ + "img/big-data.5bb9befa.svg";